import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import auth from "@/helper/auth";
import helperUmum from "@/helper/function_umum";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

window.auth = auth // inisialisasi global untuk Helper/methods.js
window.helperUmum = helperUmum 

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
